import Auth from "./auth";
import AuthEmbed from "./authEmbed";
import Profile from "./profile";
import Homepage from "./homepage";
import Misc from "./misc";

export default [
  Homepage,
  Auth,
  AuthEmbed,
  Profile,
  ...Misc,
  { path: "*", redirect: "/" }
];
